module.exports = __webpack_public_path__ + "static/media/1.31caf7c6.jpg";